import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.project.group');
import { OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-project-group',
template: templateSource || '',
    styles: [`

/* file: /opt/season-cloud-manager/project/main/build/src/app/page.project.group/view.scss */
/* src/app/page.project.group/view.scss: no such file or directory */`],
})
export class PageProjectGroupComponent implements OnInit, OnDestroy {
    public id: string = '';
    public tab: string = 'projects';
    public role: string = 'visitor';
    public data: any = null;
    public ownerInfo: any = null;
    public members: any[] = [];
    public projects: any[] = [];
    public assignableProjects: any[] = [];
    public updating: boolean = false;
    public deleteString: any = false;

    public iconMode: string = 'emoji';
    public showEmojiPicker: boolean = false;
    public emojiCategory: string = 'Objects';
    public emojiCategoryKeys: string[] = ['Objects', 'Workspace', 'Symbols', 'Colors'];
    public emojiCategories: any = {
        Objects: ['📁', '🗂️', '🧩', '💻', '🖥️', '⌨️', '🧰', '🛠️', '⚙️', '🔧', '🔐', '📦', '📌', '📊', '📈', '🧪', '🔭', '💡', '🧭', '🚀'],
        Workspace: ['🏢', '🏬', '🏛️', '🏗️', '🏠', '🌐', '☁️', '🛰️', '🗺️', '🔗', '🧱', '🧬', '💾', '🗄️', '🧮', '📡', '📍', '🎯', '🏷️', '🔖'],
        Symbols: ['✅', '🔷', '🔶', '🔹', '🔸', '💠', '🔰', '⚡', '✨', '⭐', '🌟', '💫', '⭕', '❇️', '✳️', '♻️', '🔅', '🔆', '➕', '➖'],
        Colors: ['🔴', '🟠', '🟡', '🟢', '🔵', '🟣', '🟤', '⚫', '⚪', '🟥', '🟧', '🟨', '🟩', '🟦', '🟪', '🟫', '⬛', '⬜']
    };

    public userSearch: string = '';
    public userRole: string = 'member';
    public userCandidates: any[] = [];
    public userLoading: boolean = false;
    private userKeyupTime: any = 0;

    public selectedProjectId: string = '';

    private basePath: string = '/project-group';
    private routerSub: any = null;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) {
        this.id = WizRoute.segment.id;
        this.tab = this.normalizeTab(WizRoute.segment.tab || '', this.id);
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");

        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                await this.syncRoute();
            }
        });

        await this.syncRoute(true);
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    private defaultTab(id: string) {
        return id === 'new' ? 'info' : 'projects';
    }

    private normalizeTab(tab: string, id: string) {
        if (id === 'new') return 'info';
        if (['projects', 'info', 'members'].indexOf(tab) >= 0) return tab;
        return this.defaultTab(id);
    }

    private async syncRoute(initial: boolean = false) {
        const newId = WizRoute.segment.id;
        const routeTab = WizRoute.segment.tab || '';
        const newTab = this.normalizeTab(routeTab, newId);

        if (!routeTab || routeTab !== newTab) {
            this.service.href(`${this.basePath}/${newId}/${newTab}`);
            return;
        }

        if (initial || newId !== this.id || this.data === null) {
            this.id = newId;
            this.tab = newTab;
            await this.load();
            return;
        }

        if (newTab !== this.tab) {
            this.tab = newTab;
            await this.service.render();
        }
    }

    public canManage() {
        return this.role === 'owner' || this.role === 'admin';
    }

    public tabClass(tab: string) {
        const base = 'inline-flex items-center whitespace-nowrap border-b-2 px-1 py-3 text-[13px] font-semibold transition-colors';
        if (this.tab === tab) return `${base} border-indigo-600 text-indigo-600`;
        return `${base} border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-900`;
    }

    public switchTab(tab: string) {
        const next = this.normalizeTab(tab, this.id);
        if (next === this.tab) return;
        this.service.href(`${this.basePath}/${this.id}/${next}`);
    }

    public async load() {
        this.data = null;
        await this.service.render();

        if (this.id === 'new') {
            this.role = 'owner';
            this.data = { name: '', readme: '', icon: '', emoji: '' };
            this.ownerInfo = this.service.auth.session;
            this.members = [];
            this.projects = [];
            this.assignableProjects = [];
            this.selectedProjectId = '';
            this.iconMode = 'emoji';
            await this.service.render();
            return;
        }

        const { code, data } = await wiz.call("get", { id: this.id });
        if (code !== 200) {
            this.service.href('/project');
            return;
        }
        this.data = data.group;
        this.role = data.role;
        this.ownerInfo = data.owner_info;
        this.members = data.members || [];
        this.projects = data.projects || [];
        this.assignableProjects = data.assignable_projects || [];
        this.selectedProjectId = '';
        this.iconMode = this.data?.icon ? 'upload' : 'emoji';
        await this.service.render();
    }

    public async save() {
        await this.service.render(this.updating = true);
        const { code, data } = await wiz.call("update", { data: JSON.stringify(this.data) });
        if (code === 200 && data?.id) {
            this.data = data;
            if (this.id !== data.id) {
                this.id = data.id;
                await this.service.render(this.updating = false);
                this.service.href(`${this.basePath}/${this.id}/projects`);
                return;
            }
            await this.load();
        }
        await this.service.render(this.updating = false);
    }

    public switchIconMode(mode: string) {
        this.iconMode = mode;
        this.showEmojiPicker = false;
        this.service.render();
    }

    public toggleEmojiPicker() {
        if (this.id !== 'new' && !this.canManage()) return;
        this.showEmojiPicker = !this.showEmojiPicker;
        this.service.render();
    }

    public selectEmojiCategory(category: string) {
        this.emojiCategory = category;
        this.service.render();
    }

    public selectEmoji(emoji: string) {
        if (this.id !== 'new' && !this.canManage()) return;
        this.data.emoji = emoji;
        this.data.icon = '';
        this.showEmojiPicker = false;
        this.iconMode = 'emoji';
        this.service.render();
    }

    public deleteEmoji() {
        if (this.id !== 'new' && !this.canManage()) return;
        this.data.emoji = '';
        this.service.render();
    }

    public async updateIcon() {
        if (this.id !== 'new' && !this.canManage()) return;
        this.data.icon = await this.service.file.read({ type: 'image', accept: 'image/*', width: 64, quality: 1 });
        this.data.emoji = '';
        this.iconMode = 'upload';
        await this.service.render();
    }

    public async deleteIcon() {
        if (this.id !== 'new' && !this.canManage()) return;
        this.data.icon = '';
        await this.service.render();
    }

    public async searchUsers() {
        if (!this.canManage() || this.id === 'new') return;
        const keyupTime: any = new Date().getTime();
        this.userKeyupTime = keyupTime;
        await this.service.render(300);
        if (this.userKeyupTime !== keyupTime) return;

        this.userLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call("search_users", {
            group_id: this.id,
            text: this.userSearch,
            page: 1,
            dump: 20
        });
        this.userCandidates = code === 200 ? data.rows : [];
        this.userLoading = false;
        await this.service.render();
    }

    public async addMember(user: any) {
        if (!this.canManage()) return;
        await wiz.call("add_member", { group_id: this.id, user_id: user.id, role: this.userRole });
        this.userSearch = '';
        this.userCandidates = [];
        await this.load();
    }

    public async setMemberRole(member: any, role: string) {
        if (!this.canManage() || member.is_owner) return;
        await wiz.call("update_member", { group_id: this.id, user_id: member.user_id, role });
        await this.load();
    }

    public async removeMember(member: any) {
        if (!this.canManage() || member.is_owner) return;
        if (!await this.service.modal.error(`Remove '${member.user.name}' from this group?`, `Cancel`, `Remove`)) return;
        await wiz.call("delete_member", { group_id: this.id, user_id: member.user_id });
        await this.load();
    }

    public async onProjectSelect(projectId: string) {
        this.selectedProjectId = projectId;
        await this.service.render();
    }

    public async addProject() {
        if (!this.canManage() || !this.selectedProjectId) return;
        await wiz.call("add_project", { group_id: this.id, project_id: this.selectedProjectId });
        await this.load();
    }

    public createProject() {
        if (!this.canManage()) return;
        this.service.href(`/project/new/info?group=${encodeURIComponent(this.id)}`);
    }

    public async removeProject(project: any) {
        if (!this.canManage()) return;
        if (!await this.service.modal.error(`Remove '${project.name}' from this group?`, `Cancel`, `Remove`)) return;
        await wiz.call("remove_project", { group_id: this.id, project_id: project.id });
        await this.load();
    }

    public async toggleFavorite(event: MouseEvent, project: any) {
        event.stopPropagation();
        event.preventDefault();
        if (!project.can_access) return;
        const { code, data } = await wiz.call("toggle_favorite", { project_id: project.id });
        if (code === 200) {
            project.is_favorite = data.is_favorite;
            await this.service.render();
        }
    }

    public openProject(project: any) {
        if (!project.can_access) return;
        this.service.href(`/project/${project.id}/info?group=${encodeURIComponent(this.id)}`);
    }

    public groupTitle() {
        if (this.data?.name) return this.data.name;
        return this.id === 'new' ? 'New Group' : 'Project Group';
    }

    public async deleteGroup() {
        if (this.deleteString) {
            if (this.data.name == this.deleteString) {
                if (!await this.service.modal.error(`Delete '${this.data.name}'? Projects will be ungrouped.`, `Cancel`, `Delete`)) return;
                await wiz.call("delete", { id: this.data.id });
                await this.service.href("/project");
                return;
            }
            await this.service.modal.error(`Input valid group name`, `Cancel`, `Confirm`);
        }
        this.deleteString = "";
        await this.service.render();
    }
}

export default PageProjectGroupComponent;